import {AfterContentInit, Component, OnInit, Pipe, PipeTransform} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CompanyDataService} from '../../company-account/company-data.service';
import {CandidateDataService} from '../candidate-data.service';
import {User} from '../../../../shared/models/user.model';
import {UserData} from '../../../../../crm/modules/material/data-table/material-table/material-table.component';
import {UserDataService} from '../../../../modules/auth/user-data.service';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import {Observable} from 'rxjs';
import {UserStudies} from '../../../../shared/models/userStudies.model';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

import {DatePipe} from '@angular/common';
import {UserExperienceModel} from '../../../../shared/models/userExperience.model';
import {UserCareer} from '../../../../shared/models/userCareer.model';
import {UserLanguages} from '../../../../shared/models/userLanguages.model';
import {UserSkills} from '../../../../shared/models/userSkills.model';
import {EnumTransformPipe} from '../../../../../shared-module/enumTransform/enum-transform.pipe';



@Component({
    selector: 'app-profile',
    templateUrl: './candidate-profile.component.html',
    styleUrls: ['./candidate-profile.component.scss'],
    providers: [EnumTransformPipe, DatePipe]
})
export class CandidateProfileComponent implements OnInit, AfterContentInit {
    name = 'Vlad Ionut';
    currentJob = 'Agribusiness Junior';
    location = 'Bucuresti, Romania';
    // facebook = "https://facebook.com"
    linkedin = 'https://linkedin.com'
    salary = '49'
    experienceYears = 15;

    profilePicture: string;

    candidateExperience : boolean;

    // TODO we need to change the type with User but interface is not working right yet
    candidateData: any = [];

    userRole: string;
    private testImage: any;
    private photoURL: any;

    videoCV: string;

    constructor(private candidateDataService: CandidateDataService,
                private userDataService: UserDataService,
                private enumPipe: EnumTransformPipe,
                private datePipe: DatePipe) {
    }


    ngOnInit() {
        this.candidateDataService.getUserData().subscribe(resData => {
            this.candidateData = resData;
            console.log(this.candidateData, "data")
            this.profilePicture = this.candidateData.profileImagePath;


            if(this.candidateData.linkVideoCV !== null) {
                this.videoCV = this.candidateData.linkVideoCV.replace("youtube.com/watch?v=", "youtube.com/embed/")
            }
          
            this.userRole = this.userDataService.userRole;

        }, error => {
        });
    }
    imageBase64 : any;

    async generatePdf() {
        try {
            if(this.candidateData.profileImagePath){
                console.log(this.candidateData.profileImagePath, 'path?')
                const imageUrl = this.candidateData.profileImagePath;
                this.imageBase64 = await this.candidateDataService.convertToBase64(imageUrl);
            }else{
                this.imageBase64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXMzMzPz8+vr6/Ly8vAwMCRkZHDw8PGxsaWlpaenp6Tk5PCwsK2trahoaG6urqsrKympqZJMGkaAAAFGElEQVR4nO2dbZfbKAyFEWAD5vX//9q9giT2ZLbT9pw2TXfv0zMuiWUfXQsJ/EUxhhBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQ8lsR8OXwi+vks/F3r3s5bRyxeqfD0OPR9/mts2mr/ovLJI94pOKejVs6YnO/1+Wfo8UtqVM6TltMW5ruWR3GLySGeMQUN/tk3CA7xvL7/f5hJB0lhLbVYKRtfQ/9KJhlOdYcylG/OeGkI9rBJ9V1MQ718MEfKbxSw9fkrRv1N+7GJXXMVQTR9W2Hv317eHpLrofikDTW4vE8LsZ4SHg+6/guLGekbFl8HDLFNgk16rBFe/M0WKtis73PvzyNTcDlF2MZh6ZxiN8O/ssJWT2XEXconE9ewxLS8n/9p6QZnPoIjlvXtY/GUuf8dCO+j0Ile3t0B29nrdCw7Ct4F4U+Hk78Nq5VMvgSkb8XY0nTwPXjrRTKdhxpx0ydM8y4zco+yw0ys96N4LR1NfqL54joceCLi7HEfqvEr5XwHVRhtA656NZHi/ozVw+p6REzH1OP48N1CRciZhdjmXXLiN3eakU04kpEHp4xNJ9jqCE+4sdFQKQl5O6/xvC9FGoB3TwkZB1f8tCdeQiw33nOLqwL9mos8f3ysLUZl7Y1lPs521Yt7U+VRpe+I51+5zKv04BfjKXWd6ulWCbWZgvrYZ6ein2sh+ZcD1VATId9XFfWuuEe6+E0njuHuR14H4VlJtH0bG1TTEVddWs3Y7dzY1pibzHt94+37UFbe5q7MYQ30XDbt1GIrEu7oFjo7NItKeaqFswWuyCo8bRLkDHOICKkTTR8/oPxHhP2dynmPyDlG2AHHee7hT50vGbUbRXMsUUM2+NtsW+YwuF4uI7oHakeK1gXY1TcGs8H8Q6EnuDrrDHGw7m6VIUBueVR88Om2qDz3HCWhBelbp6MncVblX2jVwvgQs53j8L+GLpzqJ/8PpeBfHljVGP3yRjD/d0WQ0IIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEELIm5PLefzL8N7/SI85Pxvw+aeeibOnmwu7n3eZN9p3/N3Pu331ggs+u3UKw1/o/I8g0dq+r3byZ9NrWQe5d8IWyXeFcjfRP+vnl83WYb02uDVuJJFHd8zebYeJH310MxsRO7u9uLEkvJFSpNcu0p144zDwtQcjvaTdde1EiKNdCuFqlt0iIKtbqNdumJBts2iT2iAQeyos1kkIJkCls0WqbRL6q9ufLoVwBRJKc9HkLm0YD53JGhnN9KbHOhXmtOcRTPdS7FRYMD2LKvTabLhZN8IZQ7n18fWzmWSVFIaz7dXtwOcsDXV64HrrpXmxw9oIP9fZYfUpPPJQ4+aH6bPlt1qqwVKYDDTKFwoF+syrG7xKyj7AFYEHMuw+MN+szTlrdPHncw5wHbNvKuxLDCbtvBjGM0VvCqVEfyrEtNeWrqgwmP7SOr7WxumvV7jyC/+QecPYirwZfs5S0UzypQnKRVoKYynaEdqvRqj3SvNQKDKPMaO0ShRXC8oQ7jKQnm4+Mnm5QjNXOIRIW5t6b3b1OSCK64xrtqAAFttWT/dWtIvyykIVp0K1/s9Bud0Qk8BiLuNjwIV6BncJ5/k/w8cHe/kpkqffTTCrNfR3bnb5OZRPN/wbyKn9XQ7/PP91fYT8j/gHpIIpSX4o390AAAAASUVORK5CYII=';
            }
            console.log(this.imageBase64,'imageBase64')
            const documentDefinition = this.getDocumentDefinition();
            pdfMake.createPdf(documentDefinition).open();
        }catch (error) {
            console.error('Error converting image:', error);
        }
    }

    getDocumentDefinition() {
        const gender = this.candidateData.gender ? this.enumPipe.transform(this.candidateData.gender) : '';
        const civilStatus = this.candidateData.civilStatus ? this.enumPipe.transform(this.candidateData.civilStatus) : '';
        const dateOfBirth = this.candidateData.dateOfBirth ? this.datePipe.transform(this.candidateData.dateOfBirth, 'dd/MM/yyyy') : '';
        const currentJob = this.candidateData.currentJob ? this.candidateData.currentJob : '';
        const currentExperienceLevel = this.candidateData.currentExperienceLevel ? ' (' + this.candidateData.currentExperienceLevel + ')' : '';

        const titleLang = this.candidateData.foreignLanguage ? 'Limbi străine' : '';
        const titleEducation = this.candidateData.allUserStudies ? 'Educație': '';
        const titleExperience = this.candidateData.userExperience ? 'Experiență': '';
        const titleAbility = this.candidateData.ability ? 'Abilitați' : '';
        const titleOtherAbility = (this.candidateData.otherCourses || this.candidateData.pcKnowledge || this.candidateData.driverLicense) ? 'Alte informații' : '';
        const otherCourses = this.candidateData.otherCourses ? 'Alte cursuri' : '';
        const pcKnowledge = this.candidateData.pcKnowledge ? 'Cunoștințe PC' : '';
        const driverLicense = this.candidateData.driverLicense ? 'Permis de conducere' : '';
        const titleSocial = (this.candidateData.facebookProfile || this.candidateData.linkedinProfile || this.candidateData.youtubeProfile || this.candidateData.twitterProfile || this.candidateData.anotherSocialMediaAccount) ? 'Social Media' : '';
        const facebook = this.candidateData.facebookProfile ? 'Facebook' : '';
        const linkedIn = this.candidateData.linkedinProfile ? 'LinkedIn' : '';
        const youTube = this.candidateData.youtubeProfile ? 'YouTube' : '';
        const twitter = this.candidateData.twitterProfile ? 'Twitter' : '';
        const otherSocial = this.candidateData.anotherSocialMediaAccount ? 'Alt canal' : '';

        return {
            info: {
                title: 'AgribusinessJob-CV-' + this.candidateData.firstName + ' ' + this.candidateData.lastName,
                author: 'AgribusinessJob'
            },
            watermark: {text: 'www.agribusinessjob.ro', color: 'green', opacity: 0.1, bold: true, italics: false},
            footer: function (currentPage, pageCount) {
                return [
                    {
                        text: currentPage.toString() + ' din ' + pageCount, alignment: 'center', opacity: 0.5
                    }]
            },
            header: function () {
                return [
                    {
                        text: 'CV generat prin intermediul site-ului www.agribusinessjob.ro',
                        alignment: 'center',
                        opacity: 0.5,
                        margin: [0, 15, 0, 10]
                    }
                ]
            },
            content: [

                {
                    style: 'section',
                    layout: 'noBorders', // optional
                    table: {

                        widths: ['50%', '50%'],
                        body: [

                            [[{
                                margin: [15, 15, 15, 0],
                                text: this.candidateData.firstName + ' ' + this.candidateData.lastName,
                                bold: true,
                                fontSize: 20,
                            },
                                {
                                    text: currentJob + currentExperienceLevel,
                                    style: 'bigTitle',
                                    margin: [15, 0, 15, 20]
                                }
                            ], []
                            ],
                            [[
                                {
                                    text: 'Adresa',
                                    style: 'mediumTitle',
                                    margin: [15, 0, 15, 0]
                                },
                                {
                                    text: this.candidateData.address,
                                    margin: [15, 0, 15, 0]
                                },
                                {
                                    text: this.candidateData.city + ', ' + this.candidateData.userCountry,
                                    margin: [15, 0, 15, 5]
                                },
                                {
                                    text: 'Telefon',
                                    style: 'mediumTitle',
                                    margin: [15, 0, 15, 0]
                                },
                                {
                                    text: this.candidateData.telephone,
                                    margin: [15, 0, 15, 5]
                                },
                                {
                                    text: 'Email',
                                    style: 'mediumTitle',
                                    margin: [15, 0, 15, 0]
                                },
                                {
                                    text: this.candidateData.email,
                                    margin: [15, 0, 15, 5]
                                },
                                {
                                    text: 'Data nasterii | Genul | Statut civil',
                                    style: 'mediumTitle',
                                    margin: [15, 0, 15, 0]
                                },
                                {
                                    text: dateOfBirth + ' | ' + gender + ' | ' + civilStatus,
                                    margin: [15, 0, 15, 15]
                                }
                            ], 
                            [
                                {
                                    image: this.imageBase64,
                                    width: 100,
                                    alignment: 'right',
                                    margin: [15, 0, 15, 0]
                                }
                            ]


                            ]
                        ]
                    },
                },
                {
                    columns: [
                        [
                            {
                                margin: [0, 20, 0, 10],
                                text: titleExperience,
                                bold: true,
                                fontSize: 20,
                                decoration: 'underline'
                            },
                            this.getExperienceObject(this.candidateData.userExperience)
                        ]
                    ]
                },
                {
                    columns: [
                        [
                            {
                                margin: [0, 20, 0, 10],
                                text: titleEducation,
                                bold: true,
                                fontSize: 20,
                                decoration: 'underline'
                            },
                            this.getEducationObject(this.candidateData.allUserStudies)
                        ]
                    ]
                },
                {
                    columns: [
                        [
                            {
                                margin: [0, 20, 0, 10],
                                text: titleLang ,
                                bold: true,
                                fontSize: 20,
                                decoration: 'underline'
                            },
                            this.getLanguagesObject(this.candidateData.foreignLanguage)
                        ]
                    ]
                },
                {
                    columns: [
                        [
                            {
                                margin: [0, 20, 0, 10],
                                text: titleAbility,
                                bold: true,
                                fontSize: 20,
                                decoration: 'underline'
                            },
                            this.getAbilitiesObject(this.candidateData.ability)
                        ]
                    ]
                },
                {
                    columns: [
                        [
                            {
                                margin: [0, 20, 0, 10],
                                text: titleOtherAbility,
                                bold: true,
                                fontSize: 20,
                                decoration: 'underline'
                            },
                            {
                                text: otherCourses,
                                style: 'mediumTitle'
                            },
                            {
                                text: this.candidateData.otherCourses,
                                margin: [0, 0, 0, 5]
                            },
                            {
                                text: pcKnowledge,
                                style: 'mediumTitle'
                            },
                            {
                                text: this.candidateData.pcKnowledge,
                                margin: [0, 0, 0, 5]
                            },
                            {
                                text: driverLicense,
                                style: 'mediumTitle'
                            },
                            {
                                text: this.candidateData.driverLicense != null ? this.candidateData.driverLicense.map(lic => lic + ', ') : null,
                                margin: [0, 0, 0, 5]
                            }
                        ]
                    ],
                }, {
                    columns: [
                        [
                            {
                                margin: [0, 20, 0, 10],
                                text: titleSocial,
                                bold: true,
                                fontSize: 20,
                                decoration: 'underline'
                            },
                            {
                                text: facebook,
                                style: 'mediumTitle'
                            },
                            {
                                text: this.candidateData.facebookProfile,
                                margin: [0, 0, 0, 5]
                            },
                            {
                                text: linkedIn,
                                style: 'mediumTitle'
                            },
                            {
                                text: this.candidateData.linkedinProfile,
                                margin: [0, 0, 0, 5]
                            },
                            {
                                text: youTube,
                                style: 'mediumTitle'
                            },
                            {
                                text: this.candidateData.youtubeProfile,
                                margin: [0, 0, 0, 5]
                            },
                            {
                                text: twitter,
                                style: 'mediumTitle'
                            },
                            {
                                text: this.candidateData.twitterProfile,
                                margin: [0, 0, 0, 5]
                            },
                            {
                                text: otherSocial,
                                style: 'mediumTitle'
                            },
                            {
                                text: this.candidateData.anotherSocialMediaAccount,
                                margin: [0, 0, 0, 5]
                            }
                        ]
            
                    ]
                }
            ],
            styles: {
                mediumTitle: {
                    fontSize: 14,
                    bold: true
                },
                bigTitle: {
                    bold: true,
                    fontSize: 18,
                    italics: true
                },
                tableHeader: {
                    bold: true,
                },
                jobTitle: {
                    fontSize: 14,
                    bold: true
                },
                employer: {
                    italics: true
                },
                section: {
                    color: '#ffffff',
                    fillColor: '#013220',
                    margin: [0, 15, 0, 5]
                }
            }
        };
    }

    getExperienceObject(experiences: UserCareer[]) {
        const exs = [];
       
        if (this.candidateData.userExperience != null) {
            experiences.forEach(experience => {
                let jobEndDate = experience.jobEndDate ? this.datePipe.transform(experience.jobEndDate, 'dd-MM-YYYY') : 'Prezent';
                exs.push(
                    [{
                        columns: [
                            [{
                                text: experience.positionHeld,
                                style: 'jobTitle'
                            },
                                {
                                    text: experience.employer,
                                    style: 'employer',
                                    margin: [0, 0, 0, 5]
                                },
                                {
                                    text: experience.mainResponsibility,
                                }],
                            [
                                {
                                    text: experience.town + ', ' + experience.country,
                                    alignment: 'right'
                                },
                                {
                                    text: this.datePipe.transform(experience.jobStartDate, 'dd-MM-YYYY') + ' - ' + jobEndDate,
                                    alignment: 'right'
                                }]
                        ]
                    }]
                );
            });
            return {
                table: {
                    widths: ['*'],
                    body: [
                        ...exs
                    ]
                }
            };
        }

    }

    getEducationObject(educations: UserStudies[]) {
        if (this.candidateData.allUserStudies != null) {
            return {
                table: {
                    widths: ['*', '*', '*', '*', '*', '*'],
                    body: [
                        [{
                            text: 'Tip studiu',
                            style: 'tableHeader'
                        },
                            {
                                text: 'Institutie',
                                style: 'tableHeader'
                            },
                            {
                                text: 'Locatie',
                                style: 'tableHeader'
                            },
                            {
                                text: 'Inceput',
                                style: 'tableHeader'
                            },
                            {
                                text: 'Final',
                                style: 'tableHeader'
                            },
                            {
                                text: 'Diploma',
                                style: 'tableHeader'
                            }
                        ],
                        ...educations.map(ed => {
                            return [this.enumPipe.transform(ed.userStudies),
                                ed.studyName,
                                ed.studyLocation,
                                this.datePipe.transform(ed.studyStartDate, 'dd-MM-YYYY'),
                                this.datePipe.transform(ed.studyEndDate, 'dd-MM-YYYY'),
                                ed.diplomaStudies];
                        })
                    ]
                }
            };
        }
    }

    getLanguagesObject(languages: UserLanguages[]) {
        if (this.candidateData.foreignLanguage != null) {
            return {
                table: {
                    widths: ['*', '*'],
                    body: [
                        [{
                            text: 'Limba',
                            style: 'tableHeader'
                        },
                            {
                                text: 'Nivel',
                                style: 'tableHeader'
                            }
                        ],
                        ...languages.map(ed => {
                            return [ed.language,
                                ed.level];
                        })
                    ]
                }
            };
        }
    }

    getAbilitiesObject(ability: UserSkills[]) {
        if (this.candidateData.ability != null) {
            return {
                table: {
                    widths: ['*', '*'],
                    body: [
                        [{
                            text: 'Abilitate',
                            style: 'tableHeader'
                        },
                            {
                                text: 'Nivel',
                                style: 'tableHeader'
                            }
                        ],
                        ...ability.map(ab => {
                            return [ab.abilityName,
                                ab.abilityLevel];
                        })
                    ]
                }
            };
        }
    }

    getBase64Image(url: string): Promise<any> {
        const promise = new Promise((resolve) => {

            const image = new Image();
            const outputFormat = 'image/png';
            image.crossOrigin = 'Anonymous';
            image.onload = () => {
                // tslint:disable-next-line: no-angle-bracket-type-assertion
                let canvas = <HTMLCanvasElement>document.createElement('CANVAS');
                // let canvas = document.createElement('CANVAS') as HTMLCanvasElement;
                const context = canvas.getContext('2d');
                let dataURL;
                canvas.height = image.height;
                canvas.width = image.width;
                context.drawImage(image, 0, 0);
                dataURL = canvas.toDataURL(outputFormat);
                canvas = null;
                resolve(dataURL);
            };
            image.src = url;
        });
        return promise;
    }


    ngAfterContentInit() {
        this.ngOnInit();
    }

}
